module.exports = __webpack_public_path__ + "img/11.996b8f0e.jpg";